import { css } from '@emotion/css';
import { theme } from 'antd';
import type React from 'react';

/**
 * Keycap-style badge for a keyboard shortcut (Tastaturkürzel), e.g. F1.
 *
 * The badge paints its own colors, so antd's disabled styling cannot reach it — a badge inside a
 * disabled control has to be told, otherwise it stays fully legible and the control looks usable.
 */
export const HotkeyBadge: React.FC<{ hotkey: string; disabled?: boolean }> = ({ hotkey, disabled }) => {
  const { token } = theme.useToken();
  return (
    <kbd
      className={css`
        display: inline-block;
        font-size: 11px;
        font-weight: 600;
        color: ${disabled ? token.colorTextDisabled : token.colorTextSecondary};
        background: ${disabled ? token.colorBgContainerDisabled : token.colorBgContainer};
        border: 1px solid ${token.colorBorderSecondary};
        border-bottom-width: 2px;
        border-radius: ${token.borderRadiusSM}px;
        padding: 1px 7px;
        line-height: 1.3;
        white-space: nowrap;
      `}
    >
      {hotkey}
    </kbd>
  );
};
